import {useEffect, useState} from 'react';
import {
    useNavigate,
    useParams
} from 'react-router-dom';

import {I18n} from '@aws-amplify/core';

import {
    Alert,
    Box,
    Button,
    List,
    Stack,
    Title
} from '@mantine/core';

import {DisplayUserState} from '../../../components/DisplayUserState';
import {useAccounts} from "../hooks/useAccounts";
import {AiOutlineHome} from "react-icons/ai";
import {getVerbosityLevel} from "../../sign-in-profiles/services/SignInProfilesService";
import {VerbosityLevel} from "../../sign-in-profiles/types";

export const NotFoundPage = () => {

    let {email} = useParams()

    let decodedEmail: string | undefined;
    try {
        decodedEmail = email ? decodeURIComponent(email) : undefined;
    } catch (e) {
        decodedEmail = email;
    }


    const navigate = useNavigate();

    const {
        accounts,
        handleFetchAccounts
    } = useAccounts();

    const [verbosity, setVerbosity] = useState<string | undefined>();

    useEffect(() => {
        handleFetchAccounts();
        getVerbosityLevel().then(level => {
            setVerbosity(level);
            if (level !== VerbosityLevel.HIGH) {
                navigate('/');
            }
        });
    }, []);

    if (verbosity !== VerbosityLevel.HIGH) {
        return null;
    }

    return (
        <Stack gap="xl" align="center" style={{maxWidth: 600, margin: 'auto'}}>
            <Title order={2}>{I18n.get('Account Not Found')}</Title>

            <Stack gap="md" style={{textAlign: 'center'}}>
                <Box>
                    You authenticated with: <strong>{decodedEmail}</strong>
                </Box>
                <Box>
                    This email address does not match any of your saved accounts.
                </Box>
            </Stack>

            {accounts.length > 0 && (
                <Stack gap="sm">
                    <Title order={5}>Your saved accounts:</Title>
                    <List>
                        {accounts.map((account, index) => (
                            <List.Item key={index}>{account.emailAddress}</List.Item>
                        ))}
                    </List>
                </Stack>
            )}

            <Alert color="blue" title="Instructions">
                Click the button below to return to the accounts page, then select an account to continue.
            </Alert>

            <Button
                onClick={() => navigate('/')}
                leftSection={<AiOutlineHome/>}
                size="md"
                style={{width: 'fit-content'}}
            >
                Start Over
            </Button>

            {<DisplayUserState accounts={accounts} enabled={false}/>}
        </Stack>
    );
};
